<template>
	<article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <div class="form js-form">

            <TextBox
              label="Label_EmailAddress"
              placeholder="Placeholder_Email"
              type="email"
              v-model="model.email"
              :validate="$v.model"
              v-on:input="$v.model.email.$touch"

              modelPath="email"
              acc="email"
            />

            <SelectList 
              label="Settings_Group_Index"
              v-model="model.group" 
              modelPath="group"
              acc="group"

              :validate="$v.model"
              v-on:input="$v.model.group.$touch"
              :options="groupOptions" 
            />

            <Btn label="Label_Next"
              class="button--right"
              v-on:click="next"
            />

          </div>
        </div>
      </div>
    </article>
  </article>
</template>

<script>
import { TextBox, Btn, SelectList } from 'components/layout/forms'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
import Submenu from 'components/views/members/Submenu'
import L from 'services/Localization'

export default {
  name: 'member-create',
  components: { Submenu, TextBox, Btn, SelectList, Validation },
  data() {
    return {
      L: L,
      model: {
        email: ''
      },
      title: L.localize('Label_Create')
    }
  },
  validations: {
    model: {
      email: { required },
      group: { required }
    }
  },
  beforeCreate() {
    this.$store.dispatch('getAllGroups').then(() => {
      this.$set(this.model, 'group', this.groups[0].id)
    })
  },
  computed: {
    ...mapGetters({
      groups: 'allGroups',
      validation: 'getValidation'
    }),
    groupOptions() {
      return this.groups.map(group => {
        return { value: group.id, label: group.name }
      })
    }
  },
  methods: {
    next() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }

      this.$store.dispatch('createMember', {
        groupId: this.model.group,
        email: this.model.email
      }).then((id) => {
        this.$router.push({name: 'member', params: { id: id }})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MemberCreate.vue?009f18ce